import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import {
  Box,
  Button,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { stores } from 'mobx-store';
import { EventDTO } from '../../DTO';
import AddEditEventModal from './EventForm';
import { useParams } from 'react-router';
import moment from 'moment';

const EventesScreen: React.FC = observer(() => {
  const { id: matchId } = useParams<{ id: string }>();
  const { liveScoringStore } = stores;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState<EventDTO | null>(null);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [eventToDelete, setEventToDelete] = useState<EventDTO | null>(null);

  useEffect(() => {
    liveScoringStore.getEventsByMatch(+matchId);
    liveScoringStore.getMatch(+matchId);
  }, [liveScoringStore, matchId]);

  const handleOpenAdd = () => {
    setSelectedEvent(null);
    setIsModalOpen(true);
  };

  const handleOpenEdit = (event: EventDTO) => {
    setSelectedEvent(event);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    liveScoringStore.getEventsByMatch(+matchId); // Refresh the list
  };

  const handleOpenDeleteDialog = (event: EventDTO) => {
    setEventToDelete(event);
    setDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setEventToDelete(null);
  };

  const handleConfirmDelete = async () => {
    if (eventToDelete) {
      await liveScoringStore.deleteEvent(eventToDelete.id);
      handleCloseDeleteDialog();
    }
  };

  return (
    <Container>
      <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h4" gutterBottom>
          Events Management
        </Typography>
        <Button variant="contained" color="primary" onClick={handleOpenAdd}>
          Add New Event
        </Button>
      </Box>

      <TableContainer component={Paper} style={{ marginTop: 20 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Event Date</TableCell>
              <TableCell>Description</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {liveScoringStore.events.map((event) => (
              <TableRow key={event.id}>
                <TableCell>{event.id}</TableCell>
                <TableCell>{event.type}</TableCell>
                <TableCell>
                  {event.eventAt
                    ? moment(event.eventAt).format('MMMM Do YYYY, h:mm:ss a')
                    : ''}
                </TableCell>
                <TableCell>{event.description || 'N/A'}</TableCell>
                <TableCell align="right">
                  <Button
                    style={{ margin: 10 }}
                    variant="outlined"
                    color="primary"
                    onClick={() => handleOpenEdit(event)}
                  >
                    Edit
                  </Button>

                  <IconButton
                    style={{ marginLeft: 5 }}
                    color="secondary"
                    onClick={() => handleOpenDeleteDialog(event)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <AddEditEventModal
        open={isModalOpen}
        onClose={handleCloseModal}
        event={selectedEvent}
      />

      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteDialogOpen} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete event: {eventToDelete?.type}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
});

export default EventesScreen;
